import { OfbizList, OfbizForm } from "@urbannex/ofbiz-forms";
import { ConfigOptions, getColumnFieldTitles, getFields, getIdFieldName, getTargets, getTitleDescriptionField } from "@urbannex/view-containers";
import { CONF_FORMS } from "./forms";

export const confOptions:ConfigOptions = {
    name:"",
    title:"Configurations Component",
    menuAndTitleOptions:{
        path:"configurations",
        headerTitle:"Configuration Information",
        menuItems:[],
        menuTag:"configurationsMenu"
    },
    listForm:new OfbizList({
      listType:"grid",
      fieldFormLocation:"local",
      listFormName:"EditProductConfigItems",
      listFormLocation:"component://kwikstore/widget/ConfigForms.xml",
      columnFields:getFields("EditProductConfigItems",CONF_FORMS),
      columnFieldTitles:getColumnFieldTitles("EditProductConfigItems",CONF_FORMS),
      remoteFormData:{
        formData:{
          formName:"EditProductConfigItems",
          formLocation:"component://kwikstore/widget/ConfigForms.xml",
          listType:"grid",
          viewIndex:1,
        },
        appContext:"catalog",
        parameters:{"productCategoryId":"CATALOG1_SEARCH"}
      },
      emptyListMessage:"No products found.  Please create new or add existing."
    }),
    addForm:new OfbizForm({
      local:true,
      formName:"EditProductConfigItem",
      formLocation:"component://kwikstore/widget/ConfigForms.xml",
      fields:getFields("EditProductConfigItem",CONF_FORMS),
      targets:getTargets("EditProductConfigItem",CONF_FORMS),
      titleDescriptionField:getTitleDescriptionField("EditProductConfigItem",CONF_FORMS),
      idFieldName:getIdFieldName("EditProductConfigItem",CONF_FORMS),
      appContext:"catalog"
    }),
    findForm:undefined,
    breadCrumbData:{
      displayPrefix:"Configuration Items",
        label:"",
        level:1,
        selectedValue:{
          "event":"list",
          "type":"EditProductConfigItems",
          "data":{
            formData:{
              listType:"grid",
              //formName:"ListProducts",
              formName:"EditProductConfigItems",
              //formLocation:"component://product/widget/catalog/ProductForms.xml",
              formLocation:"component://kwikstore/widget/ConfigForms.xml",
            },
            "endPoint":"",
            //"parameters":{"productCategoryId":"","noConditionFind":"Y"}
            //"parameters":{"productCategoryId":""}
          }
        },
        addFormText:"Create Product",
        editFormText:"Update Product"
    },
    actions:[],
    settings:[],
    relations:[
      {
        title:"Config Options",
        addContainerTitle:"Add a configuration option",
        listContainerTitle:"Configuration Options",
        listFormName:"ProductConfigOptionList",
        keyMap:{fieldName:"configItemId"},
        listForm:new OfbizList({
          listFormName:"ProductConfigOptionList",
          listType:"grid",
          listFormLocation:"component://kwikstore/widget/ConfigForms.xml",
          columnFields:getFields("ProductConfigOptionList",CONF_FORMS),
          columnFieldTitles:getColumnFieldTitles("ProductConfigOptionList",CONF_FORMS),
          appContext:"catalog",
          emptyListMessage:"No configuration options found.  Please add existing or create new",
          remoteFormData:{
            formData:{
              formName:"ProductConfigOptionList",
              formLocation:"component://kwikstore/widget/ConfigForms.xml",
              listType:"grid",
              viewIndex:1,
            },
            appContext:"catalog",
            parameters:{"productCategoryId":"CATALOG1_SEARCH"}
          }
        }),
        addFormName:"CreateConfigOption",
        addForm:new OfbizForm({
          local:true,
          formLocation:"component://kwikstore/widget/ConfigForms.xml",
          formName:"CreateConfigOption",
          fields:getFields("CreateConfigOption",CONF_FORMS),
          appContext:"catalog"
        })
      },
      {
        title:"Content",
        addContainerTitle:"Add Content to Config Item Content",
        listContainerTitle:"Config Item Content List",
        listFormName:"EditProductConfigItemContent",
        addFormName:"AddProductConfigItemContentAssoc",
        keyMap:{fieldName:"configItemId"},
        listForm:new OfbizList({
          listType:"grid",
          listFormName:"EditProductConfigItemContent",
          listFormLocation:"component://kwikstore/widget/ConfigForms.xml",
          columnFields:getFields("EditProductConfigItemContent",CONF_FORMS),
          columnFieldTitles:getColumnFieldTitles("EditProductConfigItemContent",CONF_FORMS),
          remoteFormData:{
            formData:{
              formName:"EditProductConfigItemContent",
              formLocation:"component://kwikstore/widget/ConfigForms.xml",
              listType:"grid",
              viewIndex:0,
              viewSize:20
            },
            appContext:"catalog",
            parameters:{"productCategoryId":"CATALOG1_SEARCH"}
          },
          appContext:"catalog",
          emptyListMessage:"No content found for this configuration item."
        }),
        addForm:new OfbizForm({
          local:true,
          formName:"AddProductConfigItemContentAssoc",
          formLocation:"component://kwikstore/widget/ConfigForms.xml",
          fields:getFields("AddProductConfigItemContentAssoc",CONF_FORMS),
          appContext:"catalog"
        })
      },
      {
        title:"Products",
        addContainerTitle:"",
        listContainerTitle:"Config Item Product List",
        listFormName:"ListProductConfigItem",
        addFormName:"",
        keyMap:{fieldName:"configItemId"},
        listForm:new OfbizList({
          listType:"grid",
          listFormName:"ListProductConfigItem",
          listFormLocation:"component://kwikstore/widget/ConfigForms.xml",
          columnFields:getFields("ListProductConfigItem",CONF_FORMS),
          columnFieldTitles:getColumnFieldTitles("ListProductConfigItem",CONF_FORMS),
          appContext:"catalog",
          emptyListMessage:"No products associated with this configuration item",
          remoteFormData:{
            formData:{
              formName:"ListProductConfigItem",
              formLocation:"component://kwikstore/widget/ConfigForms.xml",
              listType:"grid",
              viewIndex:1,
            },
            appContext:"catalog",
            parameters:{"productCategoryId":"CATALOG1_SEARCH"}
          }
        }),
        /* addForm:new OfbizForm({
            local:true,
            formName:"AddProductConfigItemContentAssoc",
            formLocation:"component://kwikstore/widget/ConfigForms.xml",
            fields:getFields("AddProductConfigItemContentAssoc",CONF_FORMS),
            appContext:"catalog"
          }) */
      }
    ]
  }